import { ConfigurationService } from "@oel/js-configuration";
import { IdPageEnum } from "./IdPageEnum";
import { ConfigurationGabaritSpecifiquePage } from "./ConfigurationGabaritSpecifiquePage";
import { SjtiService } from "../../services/sjti/sjti-service";

export class GabaritNavigationUtil {
    private static estSessionLegacyCharge = false;
    private static gabaritActif: IdPageEnum = GabaritNavigationUtil.obtenirGabaritActifInitial();


    static obtenirConfigurationGabarit() {
        const configGabaritActif: ConfigurationGabaritSpecifiquePage | undefined = this.dictionnaireGabaritPage.get(this.gabaritActif);
        const configGabaritGeneriqueBase = {
            typeGabarit: 'consultation',
            consultation: {
                filAriane: [],
                afficherAideContact: true,
                afficherAstuces: ConfigurationService.getConfig("oel-afficher-astuces") === "true",
                estSessionLegacyCharge: this.estSessionLegacyCharge,
                idContenuPrincipal: "titre-page-pour-retour-contenu-principal",
                idsEnvoyerEvenement: ["accueil", "recherche-transaction"],
                estContexteN3: false,
                afficherDemandeEnCours: ConfigurationService.getConfig("oel-fonctions-actives")?.includes("prospect")
            },
        }
        return this.deepMergeObjects(configGabaritGeneriqueBase, 
            configGabaritActif?.obtenirConfigurationsAfficherMenuDroite(),
            configGabaritActif?.obtenirConfigurationsTiroirPrimeurs(), 
            configGabaritActif?.obtenirConfigurationsAvecMenuDroiteEpuree(),
            configGabaritActif?.obtenirConfigurationsAideContact(), 
            configGabaritActif?.obtenirConfigurationsAvecIdentifiantMenuDroite(),
            configGabaritActif?.obtenirConfigurationsIdentifiantEntete());
    }

    private static obtenirGabaritActifInitial(): IdPageEnum {
        if (SjtiService.estProspect()) {
            return IdPageEnum.ACCUEIL_PROSPECT_ADP;
        }
        if (ConfigurationService.getConfig("oel-contexte-applicatif") === "ADA") {
            return IdPageEnum.ACCUEIL_ADA;
        }
        return IdPageEnum.ACCUEIL_ADP;
    }


    private static readonly dictionnaireGabaritPage: Map<IdPageEnum, ConfigurationGabaritSpecifiquePage> = new Map(
        Object.entries({
            // ADP
            [IdPageEnum.ACCUEIL_ADP]: [true, true, false, this.obtenirIdentifiantMenuDroiteAdp('', 'menu-droite-accueil-adp'), 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            [IdPageEnum.DETAIL_EOP_ADP]: [false, true, true, this.obtenirIdentifiantMenuDroiteAdp('menu-compact-droite-adp', 'menu-droite-details-adp'), 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            [IdPageEnum.DETAIL_MARGE_CREDIT_ADP]: [false, true, true, this.obtenirIdentifiantMenuDroiteAdp('menu-compact-droite-adp', 'menu-droite-details-adp'), 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            [IdPageEnum.ERREUR_ADP]: [false, false, false, undefined, 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            [IdPageEnum.TRANSACTIONS_ADP]: [false, false, false, undefined, 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            
            // ADP Prospect
            [IdPageEnum.ACCUEIL_PROSPECT_ADP]: [false, true, true, 'menu-droite-accueil-adp', 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            [IdPageEnum.ERREUR_PROSPECT_ADP]: [false, false, false, undefined, 'aidecontact', 'entete-consultation-adp-principal-accueil'],
            
            // ADA
            [IdPageEnum.ACCUEIL_ADA]: [false, true, false, 'menudroiteaccueilada', 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_EOP_ADA]: [false, true, true, 'menudroitedetailcompteada', 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_ES_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_ET_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_CS_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_CARTE_CREDIT_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.DETAIL_COMPTE_CREDIT_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.PAIEMENT_PAR_VERSEMENT_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
            [IdPageEnum.ERREUR_ADA]: [false, false, false, undefined, 'aidecontact-ada', undefined],
        }).map(([key, args]) => [key as IdPageEnum, new ConfigurationGabaritSpecifiquePage(...args as ConstructorParameters<typeof ConfigurationGabaritSpecifiquePage>)])
    );

    static afficherGabarit(idGabarit: IdPageEnum) {
        const ancienGabarit = this.dictionnaireGabaritPage.get(this.gabaritActif);
        const nouveauGabarit = this.dictionnaireGabaritPage.get(idGabarit);
        let nouvelleConfiguration = {
            consultation: {
                filAriane: []
            }
        };

        if (ancienGabarit?.estAfficherMenuDroite !== nouveauGabarit?.estAfficherMenuDroite) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsAfficherMenuDroite());
        }

        if (ancienGabarit?.estAfficherTiroirPrimeurs !== nouveauGabarit?.estAfficherTiroirPrimeurs) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsTiroirPrimeurs());
        }

        if (ancienGabarit?.estMenuDroiteEpuree !== nouveauGabarit?.estMenuDroiteEpuree) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsAvecMenuDroiteEpuree());
        }

        if (nouveauGabarit?.identifiantAideContact !== undefined && ancienGabarit?.identifiantAideContact !== nouveauGabarit?.identifiantAideContact) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsAideContact());
        }

        if (nouveauGabarit?.identifiantMenuDroiteActif !== undefined && ancienGabarit?.identifiantMenuDroiteActif !== nouveauGabarit?.identifiantMenuDroiteActif) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsAvecIdentifiantMenuDroite());
        }

        if (nouveauGabarit?.identifiantEntete !== undefined && ancienGabarit?.identifiantEntete !== nouveauGabarit?.identifiantEntete) {
            nouvelleConfiguration = this.deepMergeObjects(nouvelleConfiguration, nouveauGabarit?.obtenirConfigurationsIdentifiantEntete());
        }

        this.gabaritActif = idGabarit
        this.envoyerConfigurationGabarit(nouvelleConfiguration);
    }

    static declencherSessionLegacyCharge() {
        if (!this.estSessionLegacyCharge) {
            this.estSessionLegacyCharge = true;
            this.envoyerConfigurationGabarit({
                consultation: {
                    estSessionLegacyCharge: this.estSessionLegacyCharge
                }
            });
        }
    }

    private static envoyerConfigurationGabarit(configuration: any) {
        dispatchEvent(
            new CustomEvent("@navigation-gabarit/v1/appliquer-configuration", { detail: configuration })
        );
    }

    private static deepMergeObjects(target, ...sources) {
        if (!sources.length) return target;

        const source = sources.shift();

        if (typeof target === 'object' && typeof source === 'object') {
            for (const key in source) {
                if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                    if (!target[key] || typeof target[key] !== 'object') {
                        target[key] = {};
                    }
                    this.deepMergeObjects(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
        }

        return this.deepMergeObjects(target, ...sources);
    }

    private static obtenirIdentifiantMenuDroiteAdp(ancienIdentifiant: string, nouvelIdentifiant: string): string {
        return ConfigurationService.getConfig('oel-fonctions-actives')?.includes('nouveau-menu-droite-accueil-adp') ? nouvelIdentifiant : ancienIdentifiant;
    }
}
